import { render, staticRenderFns } from "./rfq-statewide.vue?vue&type=template&id=2f6050ef&scoped=true"
import script from "./rfq-statewide.vue?vue&type=script&lang=js"
export * from "./rfq-statewide.vue?vue&type=script&lang=js"
import style0 from "./rfq-statewide.vue?vue&type=style&index=0&id=2f6050ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6050ef",
  null
  
)

export default component.exports